// extracted by mini-css-extract-plugin
module.exports = {"button":"CustomModal_button__4PbeU","modal":"CustomModal_modal__LrP8e","close":"CustomModal_close___psit"};